<h1 class="page-title change-btm">FAQ'S</h1>
<p class="aff-p1">
</p>
<div class="row">
    <div class="col-lg-12">
        <div class="height-div">
            <div class="white-back2">

                <div class="clear"></div>
                <div>

                </div>




            </div>


            <div class="row">


                <div class="col-lg-6">



                    <div class="header-side-border">
                        <h1 class="text-uppercase border-heading">{{ 'GENERAL INFORMATION' | translate}}</h1>
                    </div>


                    <div class="faq-main-2">




                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'What does ILO stand for and how does it work?'|translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>

                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'ILO Stands For' | translate}}
                            </p>
                            <p>
                                {{'In the ILO platform tokens are issued as a bonus' | translate}}
                            </p>
                        </div>
                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'Will there be multiple offers for an ILO?' | translate }}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'The Ezi Crypto Community is focused on supporting the launching'| translate}}
                            </p>
                            <p>
                                {{'In support of this the platforms being created' | translate}}
                            </p>
                        </div>
                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'Who can participate in the ILO?'|translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'To qualify for participating in an ILO'| translate}}
                            </p>
                        </div>
                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'Is KYC needed to participate in the ILO?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'KYC stands for Know Your Customer'| translate}}
                            </p>
                            <p>
                                {{'All persons registering to participate in the ILO' | translate}}
                            </p>
                            <p>
                                {{'To support the KYC procedure' | translate}}
                            </p>
                        </div>
                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'What type tokens are being issued in the ILO?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'The ILO will only support the issuance of ‘utility tokens’.'| translate}}
                            </p>
                            <p>
                                {{'A utility token is a cryptocurrency' | translate}}
                            </p>
                            <p>
                                {{'A utility token can be used in paying for access' | translate}}
                            </p>
                        </div>

                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'Is the ILO an investment platform?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'The ILO platform is not created to be an investment platform'| translate}}
                            </p>
                            <p>
                                {{'It is a requirement on the ILO platform that any' | translate}}
                            </p>
                            <p>
                                {{'Anyone looking to purchase tokens as a pure' | translate}}
                            </p>
                        </div>

                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'Is the ILO a crypto currency exchange trading platform?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'No.  The ILO platform does not offer the ability for persons to trade crypto currencies.'| translate}}
                            </p>
 
                        </div>


                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'What is EZIs being issued for?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'Ezi Crypto (EZI) is the native token that has been created for the Ezi Crypto'| translate}}
                            </p>
 
                        </div>


                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'What is the amount of EZIs being issued?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'The total amount of EZI Tokens'| translate}}
                            </p>
                            <p>
                                {{'The Piptle Community can only issue more tokens' | translate}}
                            </p>
 
                        </div>

                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'How is an ILO token pricing determined?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'The token pricing is based on a fair value assumption'| translate}}
                            </p>
                            <p>
                                {{'At all times in an ILO the amount of licensing packages' | translate}}
                            </p>
                            <p>
                                {{'The value of sales being achieved through' | translate}}
                            </p>
 
                        </div>

                    </div>

                </div>


                <div class="col-lg-6">



                    <div class="header-side-border">
                            <h1 class="text-uppercase border-heading">{{'TOKEN BALANCES AND TRANSACTIONS'| translate}}</h1>
                    </div>


                    <div class="faq-main-2">




                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'What will happen to unsold Tokens?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>

                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'Tokens that are not sold in any stage will be allocated to a community'| translate}}
                            </p>
                            <p>
                                {{'A percentage of each ILO package' | translate}}
                            </p>
                        </div>
                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'Where can I see my Balance?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'You can go the left and click on Dashboard in order to see your Balance' | translate}}
                            </p>
                        </div>
                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'How do I claim the Frucoin that I have purchased in the Sale?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'All Frucoin Sale participants will have to sign up and complete a KYC. Once done you will see your Tokens in your Wallet'| translate}}
                            </p>
                        </div>
                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'How long does it take until I get my Coin?'| translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'You will be able to see your Coin immediately after your purchase'| translate}}
                            </p>
                        </div>
                        <button class="accordion grey-bg arrow-points-wrap">
                            <div class=" ">

                                <div class="faq-points-div">
                                    <p class="faq-points">{{'Are there any Bonus incentives being offered in the ICO?' | translate}}</p>
                                </div>
                                <div class="arrow-faq-div">
                                    <i class="fas fa-plus"></i>
                                </div>
                            </div>
                        </button>
                        <div class="panel">
                            <div class="bor-orng"></div>
                            <p>
                                {{'Yes. Please have a look at the ICO Information Tab in order to find out more' | translate}}
                            </p>
                        </div>
                    </div>

                </div>

            </div>















            <div class="row">


                    <div class="col-lg-6">



                        <div class="header-side-border">
                            <h1 class="text-uppercase border-heading">{{'Token Purchase'| translate}}</h1>
                        </div>


                        <div class="faq-main-2">




                            <button class="accordion grey-bg arrow-points-wrap">
                                <div class=" ">

                                    <div class="faq-points-div">
                                        <p class="faq-points">{{'Can I request a refund once I have purchased the Coin?'| translate}}</p>
                                    </div>
                                    <div class="arrow-faq-div">
                                        <i class="fas fa-plus"></i>

                                    </div>
                                </div>
                            </button>
                            <div class="panel">
                                <div class="bor-orng"></div>
                                <p>
                                    {{'The purchase of the EZI coins during the ILO is definitive' | translate}}
                                    
                                </p>
                            </div>
 
                            <button class="accordion grey-bg arrow-points-wrap">
                                <div class=" ">

                                    <div class="faq-points-div">
                                        <p class="faq-points">{{'Can I send payments from any Exchange?'| translate}}</p>
                                    </div>
                                    <div class="arrow-faq-div">
                                        <i class="fas fa-plus"></i>
                                    </div>
                                </div>
                            </button>
                            <div class="panel">
                                <div class="bor-orng"></div>
                                <p>
                                {{'If your Exchange offers the Cryptocurrencies that are supported' | translate}}
                                </p>
                            </div>
                            <button class="accordion grey-bg arrow-points-wrap">
                                <div class=" ">

                                    <div class="faq-points-div">
                                        <p class="faq-points">{{'Can I earn Free Tokens?'| translate}}</p>
                                    </div>
                                    <div class="arrow-faq-div">
                                        <i class="fas fa-plus"></i>
                                    </div>
                                </div>
                            </button>
                            <div class="panel">
                                <div class="bor-orng"></div>
                                <p>
                                    {{'Follow us on Social Media. There, you will always have the chance to get FREE Coins' | translate}}
                                </p>
                                <p>
                                    <a href="https://www.facebook.com/piptle/" class="icon-borders fb-pd mr-2" target="_blank">
                                        <img src="../../../assets/img//PIPTLE-Facebook-F-Icon.png" alt="fb-icon" class="icon-img">
                                    </a>                                 

                                    <a href="https://twitter.com/piptleit" class="icon-borders mr-2" target="_blank">
                                          <img src="../../../assets//img//PIPTLE-TwitterIcon.png" alt="twitter-icon" class="icon-img">
                                      </a>

                                      <a href="https://www.instagram.com/piptleit/" target="_blank" class="icon-borders mr-2">
                                          <img src="../../../assets//img//PIPTLE-InstagramIcon.png" alt="instagram-icon" class="icon-img">
                                      </a>

                                      <a href="https://t.me/piptler" target="_blank" class="icon-borders mr-1">
                                          <img src="../../../assets//img//telegram icon.png" alt="telegram-icon" class="icon-telegram">
                                      </a>
                              </p>
                            </div>
                            <button class="accordion grey-bg arrow-points-wrap">
                                <div class=" ">

                                    <div class="faq-points-div">
                                        <p class="faq-points">{{'Is it True that with Fruture ICO will recive future rewards?'| translate}}</p>
                                    </div>
                                    <div class="arrow-faq-div">
                                        <i class="fas fa-plus"></i>
                                    </div>
                                </div>
                            </button>
                            <div class="panel">
                                <div class="bor-orng"></div>
                                <p>
                                    {{'Once you are participating in our ICO and purchase Frucoin. You will automatically become a member of the Fruture Cooperative, this give you the possibility to get a reward for growing sustainably. For more Information please read our Whitepaper' | translate}}
                                </p>
                            </div>
                        </div>

                    </div>


                    <div class="col-lg-6">



                        <div class="header-side-border">
                                <h1 class="text-uppercase border-heading">{{'Payment options' | translate}}</h1>
                        </div>


                        <div class="faq-main-2">




                            <button class="accordion grey-bg arrow-points-wrap">
                                <div class=" ">

                                    <div class="faq-points-div">
                                        <p class="faq-points">{{'What payment options do I have?' | translate}}</p>
                                    </div>
                                    <div class="arrow-faq-div">
                                        <i class="fas fa-plus"></i>

                                    </div>
                                </div>
                            </button>
                            <div class="panel">
                                <div class="bor-orng"></div>
                                <p>
                                    {{'Once you are KYC approved you can use Cryptocurrencies and Wire Transfer to purchase Frucoin'| translate}}
                                </p>
                            </div>
                            <!-- <button class="accordion grey-bg arrow-points-wrap">
                                <div class=" ">

                                    <div class="faq-points-div">
                                        <p class="faq-points">{{'Can I use other Tokens to purchase Fru Coins?'| translate}} </p>
                                    </div>
                                    <div class="arrow-faq-div">
                                        <i class="fas fa-plus"></i>
                                    </div>
                                </div>
                            </button>
                            <div class="panel">
                                <div class="bor-orng"></div>
                                <p>
                                    {{'You can use a variety of Cryptocurrencies (see Dashboard) but not Coins'| translate}}
                                </p>
                            </div>
                            <button class="accordion grey-bg arrow-points-wrap">
                                <div class=" ">

                                    <div class="faq-points-div">
                                        <p class="faq-points">{{'How big are the rewards?'| translate}}</p>
                                    </div>
                                    <div class="arrow-faq-div">
                                        <i class="fas fa-plus"></i>
                                    </div>
                                </div>
                            </button>
                            <div class="panel">
                                <div class="bor-orng"></div>
                                <p>
                                    {{'Every user will earn 2% of the investment of their referrals using their code'| translate}}
                                </p>
                            </div> -->
                            <!-- <button class="accordion grey-bg arrow-points-wrap">
                                <div class=" ">

                                    <div class="faq-points-div">
                                        <p class="faq-points">{{'WHAT IS REFERAL RANKING SYSTEM?' | translate}}</p>
                                    </div>
                                    <div class="arrow-faq-div">
                                        <i class="fas fa-plus"></i>
                                    </div>
                                </div>
                            </button>
                            <div class="panel">
                                <div class="bor-orng"></div>
                                <p>
                                    {{'In order to purchase, you can send you can send you can send .'| translate}}
                                </p>
                            </div> -->
                            <!-- <button class="accordion grey-bg arrow-points-wrap">
                                <div class=" ">

                                    <div class="faq-points-div">
                                        <p class="faq-points">{{'What payment options do I have?'| translate}}</p>
                                    </div>
                                    <div class="arrow-faq-div">
                                        <i class="fas fa-plus"></i>
                                    </div>
                                </div>
                            </button>
                            <div class="panel">
                                <div class="bor-orng"></div>
                                <p>
                                    {{'Once you are KYC approved you can use Cryptocurrencies and Wire Transfer to purchase Frucoin'| translate}}
                                </p>
                            </div> -->
                        </div>

                    </div>

                </div>



                <div class="row">


                    <div class="col-lg-6">

                            <div class="header-side-border">
                                    <h1 class="text-uppercase border-heading">{{'Affiliates'| translate}}</h1>
                            </div>

                            <div class="faq-main-2">


                                    <button class="accordion grey-bg arrow-points-wrap">
                                        <div class=" ">

                                            <div class="faq-points-div">
                                                <p class="faq-points">{{'How do I use my Referral link?' | translate}}</p>
                                            </div>
                                            <div class="arrow-faq-div">
                                                <i class="fas fa-plus"></i>

                                            </div>
                                        </div>
                                    </button>
                                    <div class="panel">
                                        <div class="bor-orng"></div>
                                        <p>
                                            {{'You will see a link which you can copy and use for all your online marketing activities' | translate}}
                                        </p>
                                    </div>
                                    <button class="accordion grey-bg arrow-points-wrap">
                                        <div class=" ">

                                            <div class="faq-points-div">
                                                <p class="faq-points">{{'What is earned for Referrals?' | translate}}</p>
                                            </div>
                                            <div class="arrow-faq-div">
                                                <i class="fas fa-plus"></i>
                                            </div>
                                        </div>
                                    </button>
                                    <div class="panel">
                                        <div class="bor-orng"></div>
                                        <p>
                                            {{'This amount earned for making referrals' | translate}}
                                        </p>
                                    </div>
                                    <!-- <button class="accordion grey-bg arrow-points-wrap">
                                        <div class=" ">

                                            <div class="faq-points-div">
                                                <p class="faq-points">{{'How big are the rewards?'| translate}}</p>
                                            </div>
                                            <div class="arrow-faq-div">
                                                <i class="fas fa-plus"></i>
                                            </div>
                                        </div>
                                    </button>
                                    <div class="panel">
                                        <div class="bor-orng"></div>
                                        <p>
                                            {{'The amount you earn depends on which type of affiliate commission you choose.'| translate}}
                                        </p>
                                    </div> -->
                                    <!-- <button class="accordion grey-bg arrow-points-wrap">
                                        <div class=" ">

                                            <div class="faq-points-div">
                                                <p class="faq-points">{{'What is affiliate ranking system?'| translate}}</p>
                                            </div>
                                            <div class="arrow-faq-div">
                                                <i class="fas fa-plus"></i>
                                            </div>
                                        </div>
                                    </button>
                                    <div class="panel">
                                        <div class="bor-orng"></div>
                                        <p>
                                            {{'In order to purchase, you can send you can send you can send .' | translate}}
                                        </p>
                                    </div> -->
                                    <!-- <button class="accordion grey-bg arrow-points-wrap">
                                        <div class=" ">

                                            <div class="faq-points-div">
                                                <p class="faq-points">{{'What are the payments option?' | translate}}</p>
                                            </div>
                                            <div class="arrow-faq-div">
                                                <i class="fas fa-plus"></i>
                                            </div>
                                        </div>
                                    </button>
                                    <div class="panel">
                                        <div class="bor-orng"></div>
                                        <p>
                                            {{'Depending on the type of commission you can choose among cash, crypto, token or revenue share.'| translate}}
                                        </p>
                                    </div> -->
                                </div>
                    </div>


                </div>


        </div>


    </div>
</div>
